"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalToSemverMatcherContext = void 0;
var Semver_1 = require("../../utils/Semver");
function equalToSemverMatcherContext(ruleAttr) {
    var ruleSemver = new Semver_1.Semver(ruleAttr);
    return function equalToSemverMatcher(runtimeAttr) {
        var runtimeSemver = new Semver_1.Semver(runtimeAttr);
        var isEqual = ruleSemver.version === runtimeSemver.version;
        return isEqual;
    };
}
exports.equalToSemverMatcherContext = equalToSemverMatcherContext;
